import React, { useState, useEffect } from "react";
import ProjectCard from "../UiComponents/ProjectCard";
import { connect } from "react-redux";
import productActions from "../../actions/participantProduct";
import { withRouter } from "react-router-dom";
import { history } from "../../../store";
import PATHS from "../../../routes/routes-path";
import LoaderWrapper from "../Loader";
import projects from "../../../DummyData/Projects";

const HomePageParticipant = (props) => {
  const { productList, getProductList, clearProductDetail, isAuthenticating } =
    props;

  useEffect(() => {
    getProductList();
  }, []);

  const addEditProduct = (productDetail) => {
    history.push(
      productDetail.id
        ? `${PATHS.reviewProduct}${productDetail.id}?wrapper=1`
        : `/`
    );
    clearProductDetail();
  };

  return (
    <LoaderWrapper showLoader={isAuthenticating}>
      <div className="home-page-wrapper draft-wrapper-common">
        <div className="recent-header">
          <div className="recent-nav">
          <h3>Resume Review</h3>
          </div>
        </div>
        <div className="recent-body">
        {
          productList === undefined ?
          projects.map((product) => (
            <ProjectCard
              key={product.key}
              content={product.content}
              title={product.title}
              addEditProduct={addEditProduct}
            />
          )) : <div className="no-product"><h2>You haven't reviewed any product yet!</h2><h4>Please find a product and start reviewing 🎉 </h4></div>}
        </div>
        <br></br>
        <div className="recent-header">
          <div className="recent-nav">
            <h3>Product Review Recommendations</h3>
          </div>
        </div>
        <div className="recent-body">
          {productList &&
            productList.map((product, index) => (
              <ProjectCard
                key={index}
                id={product.id}
                title={product.name}
                isPublished={product.isPublished}
                addEditProduct={addEditProduct}
              />
            ))}
        </div>
      </div>
    </LoaderWrapper>
  );
};

const mapStateToProps = (state) => ({
  productList: state.participantProductReducer.productList,
  isAuthenticating: state.participantProductReducer.isAuthenticating,
});

const mapDispatchToProps = (dispatch) => ({
  getProductList: () => dispatch(productActions.getProductList()),
  clearProductDetail: () => dispatch(productActions.clearProductDetail()),
});

HomePageParticipant.propTypes = {};

HomePageParticipant.defaultProps = {};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(HomePageParticipant)
);
